import React from "react";
import {
	PieChart,
	Pie,
	Cell,
	Tooltip,
	Line,
	ResponsiveContainer,
} from "recharts";
import { formatValue, formatPercentage } from "../Utils.js";
import { fillColors } from "../../constants.js";





export const PieChartComponent = (props) => {
	const {
		data,
		title,
		
		
		
		
		name,
		value,
		subtitle,
	} = props;
	const hasData = data && Array.isArray(data) && data.length > 0;

	// Validate that data has valid numeric values
	const validData = hasData ? data.filter(item => {
		const val = item[value || 'value'];
		return val !== null && val !== undefined && !Number.isNaN(Number(val)) && Number(val) > 0;
	}) : [];


    const renderCustomizedLabelLine = (props) => {
        const { percent } = props;
        return percent > 0.02 ? <Line {...props} stroke="hsl(var(--chart-axis))" dot={false} /> : null;
    };


	const renderCustomizedLabel = (props) => {
		const { cx, cy, midAngle, outerRadius,  value: valueProp, innerRadius, percent, payload } = props;

		const RADIAN = Math.PI / 180;
		const radius = 25 + innerRadius + (outerRadius - innerRadius);
		const x = cx + radius * Math.cos(-midAngle * RADIAN);
		const y = cy + radius * Math.sin(-midAngle * RADIAN);

		// Get the label text from the payload using the name key prop
		const labelText = payload && name ? (payload[name] || payload.name || '') : '';
		const displayValue = valueProp || 0;

        if (percent > 0.02) {
            return (
                <text
                    x={x}
                    y={y}
                    fontSize="14px"
                    fill="hsl(var(--chart-axis))"
                    textAnchor={x > cx ? "start" : "end"}
                    dominantBaseline="central"
                >
                    {labelText} {formatValue(displayValue, "currency", false)}
                </text>
			);
		};
		return null;
	};

	return (
		<div className="flex flex-col h-full flex-1 overflow-hidden bg-card rounded-card border border-card-bd p-4">
			{hasData && validData.length > 0 ? (
				<div className="flex-1 min-h-0 relative">
					<div className="absolute top-0 left-0 z-10 p-2 pointer-events-none">
						<div className="text-text text-lg font-semibold widget-title" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
							{title}
						</div>
					</div>
					<div className="absolute inset-0 top-8 flex flex-col">
						{subtitle && (
							<div className="text-text-2 text-lg font-semibold text-center mb-2" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
								{subtitle}
							</div>
						)}
						<div className="flex-1 min-h-0" style={{ minHeight: '200px' }}>
							<ResponsiveContainer width="100%" height="100%">
								<PieChart>
									<Pie
										dataKey={value || 'value'}
										nameKey={name || 'name'}
										isAnimationActive={false}
										data={validData}
										cx="50%"
										cy="50%"
										outerRadius={60}
										innerRadius={40}
										fill="#8884d8"
										label={renderCustomizedLabel}
										labelLine={renderCustomizedLabelLine}
									>
										{validData && validData.map((entry, index) => (
											<Cell
												key={`cell-${index}`}
												fill={fillColors[index % fillColors.length]}
											/>
										))}
									</Pie>
									<Tooltip
										content={(props) => renderTooltip({...props, validData, valueKey: value || 'value'})}
										cursor={{ fill: "hsl(var(--chart-grid))" }}
										wrapperStyle={{zIndex: 10000 }}
									/>
								</PieChart>
							</ResponsiveContainer>
						</div>
					</div>
				</div>
			) : (
				<div className="flex-1 min-h-0 relative">
					<div className="absolute top-0 left-0 z-10 p-2 pointer-events-none">
						<div className="text-text text-lg font-semibold" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
							{title}
						</div>
					</div>
					<div className="text-text-2 text-center"></div>
				</div>
			)}
		</div>
	);
};

const renderTooltip = ({ active, payload, label, validData, valueKey }) => {
	if (active && payload && payload.length) {
		const hoveredPayload = payload[0];
		const value = hoveredPayload.value;
		
		// Calculate total from all data points, not just the payload
		const total = validData && validData.length > 0
			? validData.reduce((sum, item) => {
				const itemValue = item[valueKey || 'value'];
				return sum + (itemValue || 0);
			}, 0)
			: value; // Fallback to value if no data available
		
		const percentageOfTotal = total > 0 ? ((value / total) * 100) : 0;
		const percentageOfTotalText = `${formatPercentage(percentageOfTotal, false)} of total ${formatValue(total, "currency", false)}`;

		return (
			<div className="custom-tooltip bg-surface rounded-card border border-card-bd shadow-float px-4 py-3 p-1 minw-64 ml-8">
				<div className="flex flex-col mb-2 text-text-2">
					<div className="value" key={hoveredPayload.name}>
						<div className="flex items-center mb-2">
							<div className="flex-1">{`${hoveredPayload.name}`}</div>
						</div>
						<div className="flex items-end">
							<div className="text-xl font-semibold mr-3 flex items-baseline text-text-2">
								{`${formatValue(value, "currency", false)}`}
							</div>
						</div>
					</div>
				</div>

				<div className="text-text-2">
					{percentageOfTotalText}
				</div>
			</div>
		);
	}

	return null;
};

